import React from "react";
import { openSource } from "../../data/openSource";
import { GithubRepoCard } from "./GithubRepoCard";
import "./OpenSource.css";

function OpenSource() {
  const openSourceManaged = openSource.repos.filter((os) => os.type === "repo");
  const openSourceContribution = openSource.repos.filter(
    (os) => os.type === "pr"
  );
  return (
    <div className="open-source">
      <h1> Manged By Me ⭐️ </h1>
      {openSourceManaged.map((project) => (
        <GithubRepoCard repo={project} />
      ))}
      <h1> My Contributions 💯 </h1>
      {openSourceContribution.map((project) => (
        <GithubRepoCard repo={project} />
      ))}
    </div>
  );
}

export default OpenSource();
